import AuthorizationUtils from './utils/utils-authorization';
import FormatUtils from './utils/utils-format';
import RoutingUtils from './utils/utils-routing';
import CommonUtils from './utils/utils-common';
import MetadataUtils from './utils/utils-metadata';

/* Utils Facade */
export default class Utils {
    static formatDuration(duration, options = {}) {
        return FormatUtils.formatDuration(duration, options);
    }

    static truncate(text, options = {}) {
        return FormatUtils.truncate(text, options);
    }

    static toTitleCase(str) {
        return FormatUtils.toTitleCase(str);
    }

    static buildUrl(...paths) {
        return RoutingUtils.buildUrl(paths);
    }

    static topHitLocationDescriptor(filter, scope, topHitLabel = '', basePath = '/search') {
        return RoutingUtils.topHitLocationDescriptor(filter, scope, topHitLabel, basePath);
    }

    static catalogueLocationDescriptorString(loanFormat, filter, sortBy = null) {
        return RoutingUtils.catalogueLocationDescriptorString(loanFormat, filter, sortBy);
    }

    static joinComponents(elements, separator) {
        return CommonUtils.joinComponents(elements, separator);
    }

    static safeJoinComponents(elements, separator, tag) {
        return CommonUtils.safeJoinComponents(elements, separator, tag);
    }

    static filterUntilTextLength(elements, options = {}) {
        return CommonUtils.filterUntilTextLength(elements, options);
    }

    static getPerformerFullname(performer) {
        return MetadataUtils.getPerformerFullname(performer);
    }

    static performerPhotoUrl(performerId) {
        return MetadataUtils.performerPhotoUrl(performerId);
    }

    static withdrawnProductLine(product) {
        return MetadataUtils.withdrawnProductLine(product);
    }

    static isUserAllowedToOrder(authentication) {
        return AuthorizationUtils.isUserAllowedToOrder(authentication);
    }

    static isCustomerAllowedToOrder(authentication) {
        return AuthorizationUtils.isCustomerAllowedToOrder(authentication);
    }

    static isUserAdmin(auth) {
        return AuthorizationUtils.isUserAdmin(auth);
    }
}
